import SideMenu from "@/components/base/sideMenu";
import { useAppDispatch, useAppSelector } from "@/store";
import { useAuthState } from "@/store/auth";
import { useLayoutActions, useLayoutState } from "@/store/layout";
import { RotasEnum } from "@/utils/rotas";
import { Navigate, Outlet } from "react-router";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "../ui/sidebar";
import Loader from "../loader";


export default function PainelLayout() {
    const { logado } = useAppSelector(useAuthState)
    const { drawer } = useAppSelector(useLayoutState);
    const dispatch = useAppDispatch();
    const { setDrawer } = useLayoutActions;

    if (!logado) {
        return <Navigate to={RotasEnum.LOGIN} />
    }

    return (
        <SidebarProvider open={drawer} onOpenChange={(e) => dispatch(setDrawer(e))}>
            <SideMenu />
            <SidebarInset>
                <SidebarTrigger className="text-black w-10 h-10 border border-black my-2 mx-4" />
                <div className="w-full p-3">
                    <Outlet />
                </div>
            </SidebarInset>
            <Loader />
        </SidebarProvider>
    )

}